module.exports = __webpack_public_path__ + "img/pexels-pavel-danilyuk-7120871.de3f9d40.jpg";